// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"6263ad71","298":"78c80747","453":"b1a876a0","888":"6b7c8863"}[chunkId] + ".chunk.js";
};